import React from 'react';
import { URLS } from 'common/constants';
import { IcGift } from 'common/icons';
import { InfoBlock } from 'common/components';
import { usePersistedRecipientInfo } from 'common/hooks';
import { changeRoute } from 'common/utils';
import useTranslation from 'next-translate/useTranslation';

const GiftOrderingSection: React.FC = () => {
  const { t } = useTranslation('shoppingCart');
  const [persistedRecipientInfo] = usePersistedRecipientInfo();

  const handleSectionClick = () => {
    changeRoute(URLS.GIFT_RECIPIENT);
  };

  return (
    <InfoBlock
      key="gift"
      details={persistedRecipientInfo ? `${t('giftTo', { person: persistedRecipientInfo.name })}` : t('sendGift')}
      startIcon={IcGift}
      onActionClick={handleSectionClick}
    />
  );
};

export default GiftOrderingSection;
